import { themr as baseThemr } from './themr';
export function themr(component, defaultTheme) {
  return baseThemr('', defaultTheme)(component);
}